import { render, staticRenderFns } from "./WebsiteURL.vue?vue&type=template&id=48a42a5f&"
import script from "./WebsiteURL.vue?vue&type=script&lang=js&"
export * from "./WebsiteURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports